import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    height: 72,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-around",
    zIndex: theme.zIndex.appBar,
    width: "100vw",
    background: "rgba(255, 255, 255, 0.10)",
    backdropFilter: "blur(5px)",
  },
  item: {
    background: "unset",
    border: "unset",
    position: "relative",
    minWidth: 50,
    paddingTop: theme.spacing.space12,
    paddingBottom: theme.spacing.space16,
  },
  icon: {
    color: theme.colors.TextDefault,
  },
  active: {
    background: theme.colors.Primary,
    height: 80,
    zIndex: -1,
    position: "absolute",
    width: 64,
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
  },
  title: {
    fontSize: "10px !important",
    lineHeight: "16px",
    fontWeight: "700 !important",
  },
}));
